var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBattery50Icon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 19H44V29H40V31C40 31.7956 39.6839 32.5587 39.1213 33.1213C38.5587 33.6839 37.7957 34 37 34H7C6.20435 34 5.44129 33.6839 4.87868 33.1213C4.31607 32.5587 4 31.7956 4 31V17C4 16.2044 4.31607 15.4413 4.87868 14.8787C5.44129 14.3161 6.20435 14 7 14H37C37.7957 14 38.5587 14.3161 39.1213 14.8787C39.6839 15.4413 40 16.2044 40 17V19ZM37.7071 31.7071C37.8946 31.5196 38 31.2652 38 31V17C38 16.7348 37.8946 16.4804 37.7071 16.2929C37.5196 16.1054 37.2652 16 37 16H7C6.73478 16 6.48043 16.1054 6.29289 16.2929C6.10536 16.4804 6 16.7348 6 17V31C6 31.2652 6.10536 31.5196 6.29289 31.7071C6.48043 31.8946 6.73478 32 7 32H37C37.2652 32 37.5196 31.8946 37.7071 31.7071ZM8 29.223V18.776C8 18.5702 8.08176 18.3728 8.22728 18.2273C8.37281 18.0818 8.57019 18 8.776 18H28L16 30H8.776C8.5701 29.9997 8.37272 29.9178 8.22722 29.7721C8.08172 29.6264 8 29.4289 8 29.223Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBattery50Icon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Battery50_icon.5700536b634936d9721ec9f5953ac1a1.svg";